var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import format from 'date-fns/format';
import forEach from 'lodash/forEach';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import OutsideClickHandler from 'react-outside-click-handler';
import { getDateFnsLocaleDateFormat } from '../../util-components/datetime';
import Button from '../button';
import Icon from '../icon';
import Label from '../label';
import MultilineDateInput from '../multiline-date-input';
import MultilineTimeInput from '../multiline-time-input';
import Popover from '../popover';
import WeekdayPicker from '../weekday-picker';
import { StyledContent, StyledPopoverSchedule } from './style';
var MAXIMUM_CALENDAR_HEIGHT = 330;
export var ScheduleActions;
(function (ScheduleActions) {
    ScheduleActions["ExclusiveToggled"] = "exclusive_toggled";
    ScheduleActions["DayOfWeekChanged"] = "day_of_week_changed";
    ScheduleActions["DateChanged"] = "date_changed";
    ScheduleActions["TimeChanged"] = "time_changed";
})(ScheduleActions || (ScheduleActions = {}));
export var FlipWay;
(function (FlipWay) {
    FlipWay["TOP"] = "top";
    FlipWay["BOTTOM"] = "bottom";
})(FlipWay || (FlipWay = {}));
var SchedulePopover = /** @class */ (function (_super) {
    __extends(SchedulePopover, _super);
    function SchedulePopover(props) {
        var _this = _super.call(this, props) || this;
        _this.updateDimension = function () {
            _this.setState({
                height: window.innerHeight,
            });
        };
        _this.handleExclusiveToggled = function (event, data) {
            _this.setState({ isSetPriority: !_this.state.isSetPriority });
            if (_this.props.callback) {
                _this.props.callback(ScheduleActions.ExclusiveToggled, { checked: !_this.state.isSetPriority });
            }
        };
        _this.handleTimeOnChange = function (data) {
            if (_this.props.callback) {
                _this.props.callback(ScheduleActions.TimeChanged, { time: data });
            }
        };
        _this.handleDateOnChange = function (data) {
            if (_this.props.callback) {
                _this.props.callback(ScheduleActions.DateChanged, { date: data });
            }
        };
        _this.handleWeekdayPickerChanged = function (weekdayItems) { return __awaiter(_this, void 0, void 0, function () {
            var numEnabledDays;
            return __generator(this, function (_a) {
                numEnabledDays = 0;
                forEach(weekdayItems, function (value) {
                    if (value) {
                        numEnabledDays++;
                    }
                });
                if (numEnabledDays > 0) {
                    // callback, if weekdays have at least one one day
                    if (this.props.callback) {
                        this.props.callback(ScheduleActions.DayOfWeekChanged, { day_of_week: weekdayItems });
                    }
                }
                return [2 /*return*/];
            });
        }); };
        _this.handlePopoverClick = function () {
            _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { isSetScheduleOpen: !prevState.isSetScheduleOpen, isPopoverOpen: false })); });
        };
        _this.handleMouseEnter = function () {
            if (!_this.state.isSetScheduleOpen) {
                _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { isPopoverOpen: true })); });
            }
        };
        _this.buildDayOfWeekLabel = function (dayOfWeek) {
            var dayOfWeekLabel;
            if (Object.values(dayOfWeek).every(function (item) { return item === true; })) {
                dayOfWeekLabel = React.createElement(Label, { size: "mini", className: "everyday", active: true }, "EVERYDAY");
            }
            else {
                dayOfWeekLabel = React.createElement(React.Fragment, null,
                    React.createElement(Label, { size: "mini", active: dayOfWeek.mon }, "M"),
                    React.createElement(Label, { size: "mini", active: dayOfWeek.tue }, "T"),
                    React.createElement(Label, { size: "mini", active: dayOfWeek.wed }, "W"),
                    React.createElement(Label, { size: "mini", active: dayOfWeek.thu }, "T"),
                    React.createElement(Label, { size: "mini", active: dayOfWeek.fri }, "F"),
                    React.createElement(Label, { size: "mini", active: dayOfWeek.sat }, "S"),
                    React.createElement(Label, { size: "mini", active: dayOfWeek.sun }, "S"));
            }
            return dayOfWeekLabel;
        };
        _this.onOpen = function () {
            if (!_this.props.disabled) {
                _this.setState({ isSetScheduleOpen: true, isPopoverOpen: false });
            }
        };
        _this.getFlipDirection = function (_a) {
            var elementHeight = _a.elementHeight, elementTop = _a.elementTop;
            var elementRemainingHeight = _this.state.height - (elementHeight + elementTop);
            if (elementRemainingHeight < MAXIMUM_CALENDAR_HEIGHT) {
                return FlipWay.TOP;
            }
            return FlipWay.BOTTOM;
        };
        _this.state = {
            isSetScheduleOpen: false,
            isPopoverOpen: false,
            isSetPriority: props.isExclusiveEnabled || false,
            height: window.innerHeight,
        };
        window.addEventListener('resize', _this.updateDimension);
        return _this;
    }
    SchedulePopover.prototype.componentDidMount = function () {
        this.updateDimension();
    };
    SchedulePopover.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.updateDimension);
    };
    SchedulePopover.prototype.render = function () {
        var _this = this;
        var _a;
        var flipWay = FlipWay.BOTTOM;
        var popoverContentElement = document.getElementsByClassName('popup transition center');
        if ((_a = popoverContentElement.item(0)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) {
            var popoverContentHeight = popoverContentElement.item(0).getBoundingClientRect().height;
            var popoverContentTop = popoverContentElement.item(0).getBoundingClientRect().top;
            flipWay = this.getFlipDirection({ elementHeight: popoverContentHeight, elementTop: popoverContentTop });
        }
        var popoverContent = (React.createElement(OutsideClickHandler, { onOutsideClick: function () { return _this.setState({ isSetScheduleOpen: false }); } },
            React.createElement(StyledContent, null,
                React.createElement("div", { className: "schedule-priority" },
                    React.createElement("div", { className: "head" },
                        React.createElement("div", { className: "text" },
                            !this.props.disabled &&
                                React.createElement(Button, { mini: true, danger: this.state.isSetPriority, onClick: this.handleExclusiveToggled }, this.state.isSetPriority
                                    ? React.createElement(FormattedMessage, { id: "ui_component.schedule_popover.priority", defaultMessage: "Priority" })
                                    : React.createElement(FormattedMessage, { id: "ui_component.schedule_popover.set_as.priority", defaultMessage: "Set as Priority" })),
                            React.createElement(Popover, { inverted: true, trigger: React.createElement(Icon, { name: "info" }), content: React.createElement(FormattedMessage, { id: "ui_component.schedule_popover.help_message", defaultMessage: "Making this content a priority will let it override all other schedules and rules during the defined period." }), position: "top center" })))),
                React.createElement("div", { className: "schedule-day" },
                    React.createElement(WeekdayPicker, { disabled: this.props.disabled, items: this.props.dayOfWeek, callback: this.handleWeekdayPickerChanged })),
                React.createElement("div", { className: "schedule-time" },
                    React.createElement(MultilineTimeInput, { values: this.props.time ? this.props.time : [], disabled: this.props.disabled, callback: this.handleTimeOnChange, inverted: true })),
                React.createElement("div", { className: "schedule-date" },
                    React.createElement(MultilineDateInput, { flipWay: flipWay, disabled: this.props.disabled, inverted: true, locale: this.props.locale, values: this.props.date ? this.props.date : [], onChange: this.handleDateOnChange, disablePastDateSelection: true })))));
        var dayOfWeekLabel = this.buildDayOfWeekLabel(this.props.dayOfWeek);
        var listTime;
        var listDate;
        if (this.props.time && this.props.time.length > 0) {
            listTime = this.props.time.map(function (time, index) { return (React.createElement("h5", { key: "time-" + index },
                time.start,
                " - ",
                time.end)); });
        }
        else {
            listTime = React.createElement("h5", null, "All day");
        }
        if (this.props.date && this.props.date.length > 0) {
            listDate = this.props.date.map(function (date, index) {
                if (date.start !== undefined && date.end !== undefined) {
                    var dateStart = date.start && date.start.split('-');
                    var dateEnd = date.end && date.end.split('-');
                    return (React.createElement("h5", { key: "date-" + index },
                        date.start &&
                            format(new Date(Number(dateStart[0]), Number(dateStart[1]) - 1, Number(dateStart[2])), 'P', getDateFnsLocaleDateFormat()),
                        ' ',
                        "-",
                        ' ',
                        date.end &&
                            format(new Date(Number(dateEnd[0]), Number(dateEnd[1]) - 1, Number(dateEnd[2])), 'P', getDateFnsLocaleDateFormat())));
                }
                return;
            });
        }
        else {
            listDate = React.createElement("h5", null, "No specific date");
        }
        return (React.createElement(Popover, { className: "with-title", style: { padding: 0 }, onClose: function () { return _this.setState({ isSetScheduleOpen: false }); }, onOpen: this.onOpen, position: "bottom center", on: "click", size: "huge", trigger: React.createElement(StyledPopoverSchedule, { onMouseEnter: this.handleMouseEnter, onMouseLeave: function () { return _this.setState({ isPopoverOpen: false }); }, active: this.state.isSetScheduleOpen, disabled: this.props.disabled, className: "schedule-text" },
                React.createElement("div", { className: "schedule-row" },
                    React.createElement("div", { className: "label-group" }, dayOfWeekLabel),
                    this.props.isExclusiveEnabled &&
                        React.createElement(Label, { size: "mini", className: "priority" }, "Priority")),
                React.createElement("div", { className: "schedule-row" },
                    React.createElement("div", { className: "schedule-time" },
                        React.createElement(Icon, { name: "clock" }),
                        React.createElement("div", null, listTime)),
                    React.createElement("div", { className: "schedule-date" },
                        React.createElement(Icon, { name: "calendar" }),
                        React.createElement("div", null, listDate)))), open: this.state.isSetScheduleOpen, content: popoverContent }));
    };
    return SchedulePopover;
}(React.Component));
export { SchedulePopover };
export default SchedulePopover;
//# sourceMappingURL=index.js.map